import { render, staticRenderFns } from "./MakeComWebhookSettings.vue?vue&type=template&id=a6aa039e"
import script from "./MakeComWebhookSettings.vue?vue&type=script&lang=ts"
export * from "./MakeComWebhookSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports